import { httpGet } from "@/shared/api/http";
import { customerEndpoints } from "@/shared/api/endpoints";
import type { ApiResponse, ServiceResponse } from "@/shared/api/types";
import femaCapture from "@/shared/fema/capture";

export function sortBySourceAndCreationDate(items: any[]) {
  return [...items].sort((a, b) => {
    const aIsCustomer = a?.raw?.source === "customer_profile";
    const bIsCustomer = b?.raw?.source === "customer_profile";

    if (aIsCustomer && !bIsCustomer) return -1;
    if (!aIsCustomer && bIsCustomer) return 1;

    const dateA = new Date(a?.raw?.creationDate);
    const dateB = new Date(b?.raw?.creationDate);

    return dateB - dateA;
  });
}

export async function getCompanyDocs(
  _id: string,
  lenderName: string,
  accountNumber: string
): Promise<ServiceResponse<any[]>> {
  try {
    const customerData = JSON.parse(
      localStorage.getItem("customerData") as string
    );

    const response = await httpGet<ApiResponse>(
      customerEndpoints.getCustomerSharedDocs(
        customerData.customerId,
        lenderName,
        accountNumber
      )
    );
    return response.data;
  } catch (error) {
    femaCapture("fetching_company_docs_error", error, {
      category: "api",
      severity: "error",
      skipSanitization: false,
      user: {},
    });
    return { data: [], success: false, timestamp: new Date().toISOString() };
  }
}

export function isSameDay(isoString: string): boolean {
  const inputDate = new Date(isoString);
  const now = new Date();

  return (
    inputDate.getFullYear() === now.getFullYear() &&
    inputDate.getMonth() === now.getMonth() &&
    inputDate.getDate() === now.getDate()
  );
}

export function isWithin24Hours(isoString: string): boolean {
  const inputDate: Date = new Date(isoString);
  const now: Date = new Date();
  const diffMs: number = now.getTime() - inputDate.getTime();
  const hours24: number = 24 * 60 * 60 * 1000;
  return diffMs >= 0 && diffMs <= hours24;
}

export function ordinal(n: number): string {
  if (n % 100 >= 11 && n % 100 <= 13) {
    return `${n}th`;
  }

  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}
